import React from 'react';
import { useCart } from '../../../context/CartContext.jsx';
import CartItem from './CartItem';
import { Link } from 'react-router-dom';

const ProfileCart = () => {
    const { cartItems, cartTotal } = useCart();

    if (cartItems.length === 0) {
        return (
            <div className="text-center py-5">
                <div className="mb-4">
                    <img src="images/cart.svg" alt="empty cart" style={{ width: '80px', opacity: 0.2 }} />
                </div>
                <h4 className="fw-bold">Your cart is empty</h4>
                <p className="text-muted">Explore our collection and add items to your cart!</p>
                <Link to="/" className="btn yellow_btn mt-3">Start Shopping</Link>
            </div>
        );
    }

    return (
        <div className="profile-cart-container">
            <div className="mb-4 d-flex justify-content-between align-items-center flex-wrap gap-3">
                <h5 className="fw-bold mb-0">My Shopping Cart ({cartItems.length} items)</h5>
                <div className="text-end">
                    <p className="text-muted small mb-0">Total Amount</p>
                    <h4 className="fw-bold color_primary">{cartTotal.toFixed(2)} $</h4>
                </div>
            </div>

            <div className='card_wrapper pe-1'>
                {cartItems.map((item, i) => (
                    <CartItem key={`${item.id}-${item.size}`} item={item} />
                ))}
            </div>

            <div className="mt-4 d-flex justify-content-end">
                <Link to="/checkout" className="btn yellow_btn px-5 py-2 fw-bold">
                    PROCEED TO CHECKOUT
                </Link>
            </div>
        </div>
    );
};

export default ProfileCart;
